import { useTranslation } from 'react-i18next';
import type { FriendlyErrorCode } from '@/lib/friendlyError';
import { getOrgLoadErrorKey } from '@/lib/friendlyError';
import { Button } from '@/components/ui/Button';
import { useOrg } from '@/contexts/OrgContext';

export function OrgLoadError({ code }: { code: FriendlyErrorCode }) {
  const { t } = useTranslation();
  const { refreshOrg } = useOrg();

  return (
    <div className="mx-auto flex min-h-dvh max-w-lg flex-col items-center justify-center gap-4 p-6 text-center">
      <p className="text-sm text-[var(--fv-text-muted)]">{t(getOrgLoadErrorKey(code))}</p>
      <Button type="button" onClick={() => void refreshOrg()}>
        {t('common.retry')}
      </Button>
    </div>
  );
}
